module.exports = __webpack_public_path__ + "img/x.a19c3928.svg";